import { setPublicPath } from 'systemjs-webpack-interop'
if (window.singleSpaNavigate) {
  setPublicPath(process.env.VUE_APP_BASE_URL)
}
